import { template as template_fc76eac672574c4d924b8e6e8e21475f } from "@ember/template-compiler";
import { componentFor } from 'client-portal/utils/clinicianSearch/facets/manifest';
import Component from '@glimmer/component';
export default class RequestClinicianSearchFacetFilterContent extends Component {
    get facetComponent() {
        return componentFor(this.args.facetName);
    }
    static{
        template_fc76eac672574c4d924b8e6e8e21475f(`
    {{#if this.facetComponent}}
      <this.facetComponent />
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
